/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, fonts, mixins } from '@blend/consumer-components';

import { ChooserChoice } from '../../../TaskInputs/types';
import { mediaBreakpoints } from '../../../../../common/responsive';
import { ChoiceDoneIcon } from './ChoiceDoneIcon';
import { ChoiceButton } from './ChoiceButton';

const styles = StyleSheet.create({
  taskChoiceWrapper: {
    ...mixins.margin(0, 0, 16),
    [mediaBreakpoints.mobile]: {
      ...mixins.margin(0, 0, 8),
    },
  },
  choice: {
    alignItems: 'center',
    display: 'flex',
  },
  labelContainer: {
    overflow: 'hidden',
    marginRight: 15,
  },
  mainLabel: {
    ...mixins.textOverflow(),
    color: colors.clayPlus4,
    fontWeight: fonts.weight.medium,
    fontSize: 16,
  },
  startButton: mixins.flexPullRight(),
  button: {
    [mediaBreakpoints.mobile]: {
      height: 34,
      width: 80,
    },
  },
  completedTask: {
    display: 'inline-block',
    textAlign: 'center',
    color: colors.mint,
    width: 120,
    [mediaBreakpoints.mobile]: {
      width: 80,
    },
  },
  doneIconText: {
    marginRight: 10,
    [mediaBreakpoints.mobile]: {
      marginRight: 5,
    },
  },
});

export namespace Choice {
  export interface Props {
    choice: ChooserChoice;
    handleChoiceClick: () => void;
    buttonStyle: 'primary' | 'secondary';
  }
}

export const Choice: React.FC<Choice.Props> = ({ choice, handleChoiceClick, buttonStyle }) => {
  const { isComplete, value } = choice;
  return (
    <div className={css(styles.taskChoiceWrapper)} data-it="Choice">
      <div className={css(styles.choice)}>
        <div className={css(styles.labelContainer)}>
          <div className={css(styles.mainLabel)} data-exclude-fullstory="always">
            {choice.text}
          </div>
        </div>
        <div className={css(styles.startButton)}>
          {isComplete ? (
            <ChoiceDoneIcon value={value} />
          ) : (
            <ChoiceButton choice={choice} handleChoiceClick={handleChoiceClick} buttonStyle={buttonStyle} />
          )}
        </div>
      </div>
    </div>
  );
};
